export const ENTRY_POINT_ADDRESS = '0x5FF137D4b0FDCD49DcA30c7CF57E578a026d2789'
export const PERMIT2_ADDRESS = '0x000000000022D473030F116dDEE9F6B43aC78BA3'
export const AWC_ADDRESS = '0x293B4c7a96E876B4bcb0CD524C86304676b26b31'

export const ONETIME_LOCK_DISPATCHER_ADDRESS =
  '0xd6f3DF2C5Deace2320D7e5245806Def9cFCC5223'

export const CHAIN_ID = 421614
